import React from 'react'
import styled from 'styled-components'
import {Image, Paragraph, Pressable} from 'common/components'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 0px;
  gap: 4px;
`

const StyledInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`

const StyledImage = styled(Image)`
  height: 44px;
  width: 44px;
  border-radius: 8px;
`

const StyledSeeMore = styled(Paragraph)`
  width: fit-content;
  margin-top: -4px;
`

export default function DropboxCreationContentItem() {
  return (
    <StyledContainer>
      <Paragraph fontWeight="bold" color="gray_5">
        Monday, 4 Sep 2023, 13:00
      </Paragraph>
      <StyledInfoContainer>
        <StyledImage
          alt="folder"
          src="https://images.unsplash.com/photo-1544465544-1b71aee9dfa3?auto=format&fit=crop&q=80&w=1000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fHBob3RvfGVufDB8fDB8fHww"
        />
        <div>
          <Paragraph fontSize="m" fontWeight="medium">
            1000 photos uploaded
          </Paragraph>
          <Pressable>
            <StyledSeeMore fontWeight="medium" color="primary_5">
              See More
            </StyledSeeMore>
          </Pressable>
        </div>
      </StyledInfoContainer>
    </StyledContainer>
  )
}
